import { context, utils } from '@ad-engine/core';

const logGroup = 'Aps';

class Aps {
	private isEnabled(): boolean {
		return (
			context.get('bidders.prebid.aps') &&
			context.get('options.trackingOptIn') &&
			!context.get('options.optOutSale') &&
			!utils.isCoppaSubject()
		);
	}

	getModuleConfig(): object | undefined {
		if (!this.isEnabled()) {
			utils.logger(logGroup, 'disabled');
			return;
		}

		utils.logger(logGroup, 'enabled');

		const config = {
			name: 'apsId',
			params: {
				accountID: '3115',
			},
			storage: {
				type: 'html5',
				name: 'aps-id-system',
				expires: 1,
			},
		};

		utils.logger(logGroup, 'config', config);

		return config;
	}

	getIdPriorityConfig(): object | undefined {
		if (!this.isEnabled()) {
			utils.logger(logGroup, 'IdPriority disabled');
			return;
		}

		utils.logger(logGroup, 'IdPriority enabled');

		return {
			id5id: ['apsId', 'id5Id'],
			hadronId: ['apsId', 'hadronId'],
			idl_env: ['apsId', 'liveIntentId'],
			lotamePanoramaId: ['apsId', 'lotamePanoramaId'],
			pubcid: ['apsId', 'sharedId'],
			publinkId: ['apsId', 'publinkId'],
			'33acrossId': ['apsId', '33acrossId'],
			connectId: ['apsId', 'connectId'],
		};
	}

	getAnalyticsConfig(): object | undefined {
		if (!this.isEnabled()) {
			utils.logger(logGroup, 'Analytics disabled');
			return;
		}

		utils.logger(logGroup, 'prebid enabling APS Analytics');

		return {
			provider: 'apsAnalytics',
			options: {
				accountID: '3115',
			},
		};
	}
}

export const aps = new Aps();
